import React, {FC, ReactNode, useMemo} from 'react';

import {RendererOf} from '../../libs/shared/helpers/src/react/reactHelpers';
import {ItemsFormatter, OthersTextDecorator} from './itemsFormatter';

/*
 * Props.
 */

interface CommaFormatterProps {
  /** The item names to render. */
  items: ReadonlyArray<string>;
  /** The maximum number of names to display. */
  limit?: number;
  /** Render name. */
  renderName?: RendererOf<ReactNode>;
  /** Render "X others" text. */
  renderOthersText?: OthersTextDecorator;
}

/*
 * Component.
 */

export const CommaFormatter: FC<CommaFormatterProps> = (props) => {
  const {items} = props;
  const memoItems = useMemo(
    () =>
      items.map((item) => ({
        id: item,
        name: item,
      })),
    [items],
  );
  return (
    <ItemsFormatter
      items={memoItems}
      limit={props.limit ?? 3}
      renderName={props.renderName}
      renderOthersText={props.renderOthersText}
    />
  );
};
